import React from "react";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
} from "@material-ui/core";

import AdjustIcon from "@material-ui/icons/Adjust";
import BUELogo from "../../Assets/BUE.png";
import LSBU from "../../Assets/LSBULogo.png";

const steps = [
  {
    label: "The British University in Egypt",
    description: `Bachelor degree in computer science from The British University
    in Egypt.`,
    logo: BUELogo,
  },
  {
    label: "London South Bank University ",
    description: "Accredited from London South Bank University",
    logo: LSBU,
  },
];

export default function EducationStepper() {
  const isSamll = useMediaQuery("(min-width:900px)");
  return (
    <Grid
      style={{
        display: "flex",
        backgroundColor: "inherit",
        padding: "3rem",
        justifyContent: "space-around",
        alignItems: "center",
        flexDirection: isSamll ? "row" : "column",
      }}
    >
      {steps.map((step) => (
        <Box
          key={step.label}
          style={step.logo === BUELogo ? null : { paddingInline: "5rem" }}
        >
          {step.label === " " ? null : (
            <Box icon={<AdjustIcon color="secondary" />} className="eduTitle">
              {step.label}
            </Box>
          )}

          <Box style={{ paddingTop: "30px" }}>
            <Grid container spacing={0}>
              <Grid
                item
                md={12}
                sm={12}
                xs={12}
                style={{ alignSelf: "center" }}
              >
                {step.logo ? (
                  <Box
                    component="img"
                    src={step.logo}
                    style={{
                      width: 100,
                      height: 100,
                      paddingBottom: "20px",
                    }}
                    alt=""
                  />
                ) : null}
                <Typography
                  style={{ marginBottom: isSamll ? "5%" : "" }}
                  className="steps"
                >
                  {step.description}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
      ))}
    </Grid>
  );
}
